/**
 * Die einheitliche Sicherungsnummer "S-<n>" (Migration 057, `fx_deals.seq`, systemvergeben).
 * Der Server liefert sie als `nummer`; ohne sie (Altdaten im Zwischenspeicher) wird sie aus `seq`
 * gebildet. Das bisherige freie Feld `no` ist nur noch Zusatzinfo (z. B. Banknummer) - und der
 * letzte Rueckfall, damit nie eine leere Kennung erscheint.
 */
export interface MitSicherungsNummer {
  nummer?: unknown;
  seq?: unknown;
  no?: unknown;
}

export function sicherungsNr(deal: MitSicherungsNummer | null | undefined): string {
  if (!deal) return "";
  if (typeof deal.nummer === "string" && deal.nummer) return deal.nummer;
  if (deal.seq !== undefined && deal.seq !== null && deal.seq !== "") return `S-${String(deal.seq)}`;
  return String(deal.no ?? "");
}

/** Die bisherige freie Nummer als Zusatzinfo, nur wenn sie von `S-<n>` abweicht. */
export function sicherungsZusatz(deal: MitSicherungsNummer | null | undefined): string {
  if (!deal) return "";
  const no = String(deal.no ?? "");
  return no && no !== sicherungsNr(deal) ? no : "";
}
